import { useState, useEffect, useRef } from 'react';
import axios from 'axios';

export const useModules = (userId) => {
  const [selectedModule, setSelectedModule] = useState(null);
  const [completedModules, setCompletedModules] = useState([]);
  const [accessibleModules, setAccessibleModules] = useState([]);
  const [passageCounts, setPassageCounts] = useState({});
  const [isModuleLoading, setIsModuleLoading] = useState(false);
  const [showModuleInfo, setShowModuleInfo] = useState(false);
  
  const [moduleInfoMessage, setModuleInfoMessage] = useState('');
  const [isFirstMessageReady, setIsFirstMessageReady] = useState(false);

  // Subtopic states
  const [showSubtopicModal, setShowSubtopicModal] = useState(false);
  const [subtopics, setSubtopics] = useState([]);
  const [isLoadingSubtopics, setIsLoadingSubtopics] = useState(false);
  const [randomUserInterest, setRandomUserInterest] = useState("");
  const [selectedSubtopic, setSelectedSubtopic] = useState('');
  
  // Quiz States
  const [showQuizModal, setShowQuizModal] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [isLoadingQuestions, setIsLoadingQuestions] = useState(false);
  const [videoFileName, setVideoFileName] = useState("");
  
  const abortControllerRef = useRef(null);

  const fetchModuleData = async (userId) => {
    if (!userId) return;
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/get_user_module_data`,
        { user_id: userId },
        { headers: { 'Content-Type': 'application/json' } }
       );
    
      setCompletedModules(response.data.completed_modules);
      setAccessibleModules(response.data.accessible_modules);
      setPassageCounts(response.data.passage_counts || {});
    
      return { success: true };
    } catch (error) {
      console.error('Error fetching module data:', error);
      return { success: false, error };
    }
  };
  
  const getPassageSubtopics = async () => {
    setShowSubtopicModal(true);
    setIsLoadingSubtopics(true);
    abortControllerRef.current = new AbortController();

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/get_passage_subtopics`,
        { user_id: userId },
        {
          signal: abortControllerRef.current.signal,
          headers: { 'Content-Type': 'application/json' },
        }
      );

      setSubtopics(res.data.passage_subtopics);
      setRandomUserInterest(res.data.user_interest);
      setIsLoadingSubtopics(false);
      return { success: true };
    } catch (err) {
      if (axios.isCancel(err) || err.name === 'CanceledError' || err.name === 'AbortError') {
        console.log('Request cancelled');
      } else {
        console.error('Error getting subtopics:', err);
      }
      setShowSubtopicModal(false);
      return { success: false, error: err };
    } finally {
      setIsModuleLoading(false);
    }
  };

  const abortOngoingRequests = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
  };

  const getQuestions = async (moduleId) => {
    setShowQuizModal(true);
    setIsLoadingQuestions(true);
    abortControllerRef.current = new AbortController();

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/get_module_questions`,
        { module_id: moduleId },
        {
          signal: abortControllerRef.current.signal,
          headers: { 'Content-Type': 'application/json' },
        }
      );
      console.log('questions count=', res.data.questions)
      console.log('questions video filename=', res.data.video_filename)
      setQuestions(res.data.questions);
      setVideoFileName(res.data.video_filename);
      setIsLoadingQuestions(false);
      return { success: true };
    } catch (err) {
      if (axios.isCancel(err) || err.name === 'CanceledError' || err.name === 'AbortError') {
        console.log('Request cancelled');
      } else {
        console.error('Error getting Questions:', err);
      }
      setShowQuizModal(false);
      return { success: false, error: err };
    } finally {
      setIsModuleLoading(false);
    }
  };
  return {
    // State
    selectedModule, setSelectedModule,
    completedModules, setCompletedModules,
    accessibleModules, setAccessibleModules,
    passageCounts, setPassageCounts,
    isModuleLoading, setIsModuleLoading,
    showModuleInfo, setShowModuleInfo,
    moduleInfoMessage, setModuleInfoMessage,
    isFirstMessageReady, setIsFirstMessageReady,
    showSubtopicModal, setShowSubtopicModal,
    subtopics, setSubtopics,
    selectedSubtopic, setSelectedSubtopic,
    showQuizModal, setShowQuizModal,
    questions, setQuestions,
    isLoadingSubtopics,
    isLoadingQuestions,
    randomUserInterest,
    videoFileName,
    
    // Methods
    fetchModuleData,
    getPassageSubtopics,
    getQuestions,
    abortOngoingRequests
  };
};
